'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialBundleState = getInitialBundleState;
exports.generateBundleUrl = generateBundleUrl;
exports.bundleMerchandiseIds = bundleMerchandiseIds;

var _immutable = require('immutable');

var _params = require('hub-http/helpers/params');

var parseList = function parseList(list) {
  if (list === '') return (0, _immutable.Set)();
  if (!Array.isArray(list)) return (0, _immutable.Set)([JSON.parse(list)]);
  return (0, _immutable.Set)(list.map(function (item) {
    return JSON.parse(item);
  }));
};

function getInitialBundleState() {
  var queryString = window.location.search.replace('?', '');
  var params = (0, _params.parse)(queryString);
  try {
    var _params$marketingPlan = params.marketingPlanSelected,
        marketingPlanSelected = _params$marketingPlan === undefined ? null : _params$marketingPlan,
        _params$salesPlanSele = params.salesPlanSelected,
        salesPlanSelected = _params$salesPlanSele === undefined ? null : _params$salesPlanSele,
        _params$servicePlanSe = params.servicePlanSelected,
        servicePlanSelected = _params$servicePlanSe === undefined ? null : _params$servicePlanSe,
        _params$marketingUnit = params.marketingUnits,
        marketingUnits = _params$marketingUnit === undefined ? null : _params$marketingUnit,
        _params$salesUnits = params.salesUnits,
        salesUnits = _params$salesUnits === undefined ? null : _params$salesUnits,
        _params$serviceUnits = params.serviceUnits,
        serviceUnits = _params$serviceUnits === undefined ? null : _params$serviceUnits,
        _params$selectedAddOn = params.selectedAddOns,
        selectedAddOns = _params$selectedAddOn === undefined ? [] : _params$selectedAddOn,
        _params$selectedServi = params.selectedServices,
        selectedServices = _params$selectedServi === undefined ? [] : _params$selectedServi;

    return {
      marketingPlanSelected: JSON.parse(marketingPlanSelected),
      salesPlanSelected: JSON.parse(salesPlanSelected),
      servicePlanSelected: JSON.parse(servicePlanSelected),
      marketingUnits: JSON.parse(marketingUnits),
      salesUnits: JSON.parse(salesUnits),
      serviceUnits: JSON.parse(serviceUnits),
      selectedAddOns: parseList(selectedAddOns),
      selectedServices: parseList(selectedServices)
    };
  } catch (e) {
    return {
      marketingPlanSelected: null,
      salesPlanSelected: null,
      servicePlanSelected: null,
      marketingUnits: null,
      salesUnits: null,
      serviceUnits: null,
      selectedAddOns: (0, _immutable.Set)(),
      selectedServices: (0, _immutable.Set)()
    };
  }
}

function generateBundleUrl(_ref) {
  var marketingPlanSelected = _ref.marketingPlanSelected,
      salesPlanSelected = _ref.salesPlanSelected,
      servicePlanSelected = _ref.servicePlanSelected,
      marketingUnits = _ref.marketingUnits,
      salesUnits = _ref.salesUnits,
      serviceUnits = _ref.serviceUnits,
      selectedAddOns = _ref.selectedAddOns,
      selectedServices = _ref.selectedServices;
  var _window$location = window.location,
      origin = _window$location.origin,
      pathname = _window$location.pathname;

  var rootUrl = '' + origin + pathname;

  var queryString = (0, _params.stringify)({
    marketingPlanSelected: marketingPlanSelected,
    salesPlanSelected: salesPlanSelected,
    servicePlanSelected: servicePlanSelected,
    marketingUnits: marketingUnits,
    salesUnits: salesUnits,
    serviceUnits: serviceUnits,
    selectedAddOns: selectedAddOns.toJS(),
    selectedServices: selectedServices.toJS()
  });

  return queryString ? rootUrl + '?' + queryString : rootUrl;
}

function bundleMerchandiseIds(_ref2) {
  var marketingPlanSelected = _ref2.marketingPlanSelected,
      salesPlanSelected = _ref2.salesPlanSelected,
      servicePlanSelected = _ref2.servicePlanSelected,
      selectedAddOns = _ref2.selectedAddOns,
      selectedServices = _ref2.selectedServices;

  var merchandiseIds = [];
  if (marketingPlanSelected) {
    merchandiseIds.push(marketingPlanSelected);
  }
  if (salesPlanSelected) {
    merchandiseIds.push(salesPlanSelected);
  }
  if (servicePlanSelected) {
    merchandiseIds.push(servicePlanSelected);
  }
  selectedAddOns.forEach(function (merchandiseId) {
    return merchandiseIds.push(merchandiseId);
  });
  selectedServices.forEach(function (merchandiseId) {
    return merchandiseIds.push(merchandiseId);
  });
  return merchandiseIds;
}


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/utils.js
// module id = 577
// module chunks = 3 4